export default __webpack_public_path__ + "static/media/delivery-box-add-operation-01.3561a77e.png";